import { useLeadCreateStore } from './useLeadCreateStore';
import { useLeadSidebarStore } from './useLeadSidebarStore';

export const customModalsConfig = [
  {
    key: 'createLead',
    import: () => import('../views/CreateLead'),
    store: useLeadCreateStore,  // <-- Pass the function directly!
  },
  {
    key: 'leadSideBar',
    import: () => import('../views/LeadSidebar'),
    store: useLeadSidebarStore,  // <-- Pass the function directly!
  },
];